import { MainAPiServiceService } from '@_services/main-api-service.service';
import { TooltipService } from '@_services/tooltip.service';
import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-conveyancing-price-deposite',
  templateUrl: './conveyancing-price-deposite.component.html',
  styleUrls: ['./conveyancing-price-deposite.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConveyancingPriceDepositeComponent implements OnInit, OnDestroy {
  errorWarningData: any = {};
  @Input() MatterConveyancingDetailsForm: FormGroup;
  BALANCEVAL: any;
  DepositType: any = [];
  @Input() toolTipList: any;
  toolTipPostion = 'above';
  @Input() testBool;
  sub: Subscription;
  constructor(
    private datepipe: DatePipe,
    private _mainAPiServiceService: MainAPiServiceService,
    public tooltipService: TooltipService,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    let deposit_typeLookups = localStorage.getItem('deposit_type');
    if (deposit_typeLookups && deposit_typeLookups != 'null') {
      this.DepositType = JSON.parse(deposit_typeLookups);
      // this.isLoadingResults = false;
    } else {
      this.sub = this._mainAPiServiceService
        .getSetData({ Action: 'getdata', Filters: { LookupType: 'Deposit Type' } }, 'lookup')
        .subscribe((responses) => {
          if (responses.CODE === 200 && responses.STATUS === 'success') {
            this.DepositType = responses.DATA.LOOKUPS;
            localStorage.setItem('deposit_type', JSON.stringify(responses.DATA.LOOKUPS));
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  /**
   * This function is used to get the text data.
   */
  myFunction(event: any) {
    navigator.clipboard.writeText(event);
  }

  get f() {
    return this.MatterConveyancingDetailsForm.controls;
  }

  /**
   * This function is used to calculate the balance
   */
  calcBalance() {
    const purchasePrice = parseFloat(
      (this.f.PURCHASEPRICE.value || '0').toString().replace(/,/g, ''),
    );
    const initialDeposit = parseFloat(
      (this.f.INITIALDEPOSIT.value || '0').toString().replace(/,/g, ''),
    );
    const balanceDeposit = parseFloat(
      (this.f.BALANCEDEPOSIT.value || '0').toString().replace(/,/g, ''),
    );

    const balance = purchasePrice - (initialDeposit + balanceDeposit);

    const value = isNaN(balance) ? 0 : parseFloat(balance.toFixed(2));
    this.MatterConveyancingDetailsForm.controls['BALANCEVAL'].setValue(value);
  }

  /**
   * This function is used to get the comman date picker data
   */
  CommanDatePickerClick(type: string, event: MatDatepickerInputEvent<Date>, formControlVar) {
    this.MatterConveyancingDetailsForm.controls[formControlVar].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
  }
}
